import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiDispatch } from '../../shared/ui/action.js';
import { useGenUiI18n } from '../../shared/ui/i18n.js';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { MobilityRideDetailsCard } from './ui/mobility_ride_details.js';
import { maskPhone } from '../shared/phone/phone_mask.js';

type MobilityRideDetailsUi = Extract<ChatUi, { kind: 'mobility_ride_details' }>;

/**
 * O Continuar volta por `interaction` (o challenge do card + a
 * `MobilityRideDetailsSubmit`): o agente guarda o telefone e as observações sem
 * o LLM reinterpretar o texto. O eco é a fala que a pessoa aparenta ter dito.
 */
function MobilityRideDetailsEntry({
  ui,
  note,
  readOnly,
  superseded,
  dispatch,
}: Readonly<{
  ui: MobilityRideDetailsUi;
  note?: string;
  readOnly?: boolean;
  superseded?: boolean;
  dispatch: GenUiDispatch;
}>) {
  const { t } = useGenUiI18n();
  return (
    <MobilityRideDetailsCard
      ui={ui}
      {...(note ? { note } : {})}
      {...(readOnly ? { readOnly } : {})}
      {...(superseded ? { superseded } : {})}
      onSubmit={(submit) => {
        const phone = maskPhone(submit.phone);
        const said = ui.travelerName
          ? t('mobilityRideDetails.echoOf', { name: ui.travelerName, phone })
          : t('mobilityRideDetails.echoSelf', { phone });
        dispatch({
          type: 'interaction',
          interactionId: ui.challengeId,
          text: submit.notes
            ? `${said} ${t('mobilityRideDetails.echoNotes', { notes: submit.notes })}`
            : said,
          data: submit,
        });
      }}
    />
  );
}

/** Entrada de catálogo do `mobility_ride_details` (slot chat). */
export const mobilityRideDetailsEntry: GenUiEntry<MobilityRideDetailsUi> = {
  kind: 'mobility_ride_details',
  slot: 'chat',
  policy: { productOf: () => 'mobility' },
  render: ({ ui, note, readOnly, superseded, dispatch }) => (
    <MobilityRideDetailsEntry
      ui={ui}
      {...(note ? { note } : {})}
      {...(readOnly ? { readOnly } : {})}
      {...(superseded ? { superseded } : {})}
      dispatch={dispatch}
    />
  ),
};
